<template>
    <div class="card" >
        <div class="card-header">
            <h4 class="card-title">
                {{$t("cajonInteligente")}}
            </h4>
            <p class="card-category">
                {{$t("situacionActualDeLosNivelesDelCajonInteligente")}}
            </p>
            <div class="text-right" v-if="smartCash">
                <router-link :to="{name:'online-cajon-inteligente', params:{idBusiness:idBusiness}}">
                    <span class="verTodos"><i class="fa fa-eye"></i> {{$t("verDetallesDeNiveles")}}</span>
                </router-link>
            </div>
        </div>
        <div class="card-body">
            <div class="row" v-if="smartCash">
                <div class="col-md-4">
                    <h4 style='padding:10px; border: 1px dashed black; background-color:#eee; margin-top:10px;'><strong>{{$t("totalMonedas")}}: <template v-if="cashGlory">{{getTotalTable1TotalCasete | currency}}</template><template v-else>{{getTotalTable1TotalCasete + getTotalTable1TotalReci | currency}}</template> </strong></h4>
                </div>
                <div class="col-md-4">
                    <h4 style='padding:10px; border: 1px dashed black; background-color:#eee; margin-top:10px;'><strong>{{$t("totalBilletes")}}: <template v-if="cashGlory">{{getTotalTable2TotalCasete | currency}}</template> <template v-else>{{getTotalTable2TotalCasete + getTotalTable2TotalReci | currency}}</template> </strong></h4>
                </div>
                <div class="col-md-4">
                    <h4 style='padding:10px; border: 1px dashed black; background-color:#dff0d8; margin-top:10px;'><strong>{{$t("total")}}: <template v-if="cashGlory">{{getTotalTable2TotalCasete + getTotalTable1TotalCasete| currency}}</template><template v-else>{{getTotalTable1TotalCasete + getTotalTable1TotalReci + getTotalTable2TotalCasete + getTotalTable2TotalReci | currency}}</template> </strong></h4>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-12">
                    <div class="alert alert-danger" role="alert">
                        {{$t("noHayCajonInteligenteParaMostrar")}}. {{$t("consulteConSuDistribuidor")}}.
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <hr>
            <div class="stats">
                <i class="fa fa-clock"></i> {{lastDate | timeago}}
            </div>
        </div>
    </div>

</template>

<script>

    import swal from 'sweetalert2'
    import Ticket from '../../../Widgets/Ticket.vue'

    export default {
        name: "CajonInteligente",

        created() {
            this.getSmartCash();
            this.getConfigTpv();
        },
        props: ['onlineDetails', 'lastDate', 'idBusiness'],
        data() {
            return {
                smartCash:[],
                cashGlory:false,
            }
        },
        components: {
            Ticket,
        },
        computed:{

            getTotalTable1NivelReci(){

                var total=this.smartCash.reciclador2+this.smartCash.reciclador1+this.smartCash.reciclador50c+this.smartCash.reciclador20c+this.smartCash.reciclador10c+this.smartCash.reciclador5c+this.smartCash.reciclador2c+this.smartCash.reciclador1c;

                return total;
            },

            getTotalTable1TotalReci(){

                var total=(this.smartCash.reciclador2*2)+(this.smartCash.reciclador1*1)+(this.smartCash.reciclador50c*0.5)+(this.smartCash.reciclador20c*0.2)+(this.smartCash.reciclador10c*0.1)+(this.smartCash.reciclador5c*0.05)+(this.smartCash.reciclador2c*0.02)+(this.smartCash.reciclador1c*0.01);

                return total;
            },

            getTotalTable1NivelCasete(){

                var total=this.smartCash.casete2+this.smartCash.casete1+this.smartCash.casete50c+this.smartCash.casete20c+this.smartCash.casete10c+this.smartCash.casete5c+this.smartCash.casete2c+this.smartCash.casete1c;

                return total;
            },

            getTotalTable1TotalCasete(){

                var total=(this.smartCash.casete2*2)+(this.smartCash.casete1*1)+(this.smartCash.casete50c*0.5)+(this.smartCash.casete20c*0.2)+(this.smartCash.casete10c*0.1)+(this.smartCash.casete5c*0.05)+(this.smartCash.casete2c*0.02)+(this.smartCash.casete1c*0.01);

                return total;
            },


            getTotalTable2NivelReci(){

                var total=this.smartCash.reciclador500+this.smartCash.reciclador200+this.smartCash.reciclador100+this.smartCash.reciclador50+this.smartCash.reciclador20+this.smartCash.reciclador10+this.smartCash.reciclador5;

                return total;
            },

            getTotalTable2TotalReci(){

                var total=(this.smartCash.reciclador500*500)+(this.smartCash.reciclador200*200)+(this.smartCash.reciclador100*100)+(this.smartCash.reciclador50*50)+(this.smartCash.reciclador20*20)+(this.smartCash.reciclador10*10)+(this.smartCash.reciclador5*5);

                return total;
            },

            getTotalTable2NivelCasete(){

                var total=this.smartCash.casete500+this.smartCash.casete200+this.smartCash.casete100+this.smartCash.casete50+this.smartCash.casete20+this.smartCash.casete10+this.smartCash.casete5;

                return total;
            },

            getTotalTable2TotalCasete(){

                var total=(this.smartCash.casete500*500)+(this.smartCash.casete200*200)+(this.smartCash.casete100*100)+(this.smartCash.casete50*50)+(this.smartCash.casete20*20)+(this.smartCash.casete10*10)+(this.smartCash.casete5*5);

                return total;
            },


        },
        methods: {

            getConfigTpv() {

                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt,
                        numConfig:16,
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                    .then(function (response) {
                        if (response.data.response) {

                            vm.cashGlory = true;

                        }

                    })
                    .catch(function (error) {
                        console.log(error);
                    });


            },

            getSmartCash() {

                var tpvs = [];
                this.onlineDetails.forEach(function (x) {
                    if (x && x.online == 1) {
                        tpvs.push(x.idTpv);
                    }
                });


                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        listTpv: JSON.stringify(tpvs),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getSmartCash", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.smartCash = response.data.result;
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },


        },
        watch: {
            onlineDetails: function (newOnlineDetails, oldOnlineDetails) {
                this.getSmartCash();
            }
        },
    }
</script>

<style scoped>

    .card-body {
        padding: 10px 15px;
    }

    .title {
        font-weight: bold;
    }

    tfoot tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }

    .card-category {
        color: #9a9a9a
    }

    .verTodos {
        font-size: 0.9em
    }


</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Online/Widgets/CajonInteligente.vue